// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__I34lD","disabled":"FileBtn_disabled__1YKsi","warn":"FileBtn_warn__3xHKx","fade":"FileBtn_fade__3Ikdk"};